// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_c2-0";
export var orangeButton = "_c2-1";